import React from "react";
// Material imports
import { ThemeProvider } from "@mui/material/styles";
// Limitless imports
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import Box from "@limitless/modern/layout/Box";
import { useExpertPaymentsContext, useExpertProfileContext } from "@limitless/expert";
import { usePageViewRecorder } from "@limitless/analytics";
import { useNavigation } from "@limitless/portal";
import { useTranslation } from "@limitless/common/hooks";
import AvailableToWithdraw from "../components/payment/AvailableToWithdraw";
import WithdrawlHistory from "../components/payment/WithdrawlHistory";
import Rewards from "../components/payment/Rewards";

const PaymentScreen = () => {
    const { loadExpertPayments } = useExpertPaymentsContext();
    const { navigate } = useNavigation();
    const { t } = useTranslation();

    usePageViewRecorder("Payment");

    React.useEffect(() => {
        loadExpertPayments();
    }, []);

    const { isDarkMode } = useExpertProfileContext();
    const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    padding: theme => `${theme.spacing(3)} ${theme.spacing(3)} ${theme.spacing(5)} ${theme.spacing(4)}`,
                    height: "calc(100vh - 126px)",
                    width: "calc(100vw - 137px)"
                }}
            >
                <div
                    style={{
                        backgroundColor: "transparent",
                        display: "grid",
                        height: "100%",
                        gridAutoColumns: "1fr",
                        gridTemplateColumns: "33.6fr 66.4fr",
                        gridTemplateRows: "auto 1fr",
                        gap: "20px 24px",
                        gridTemplateAreas: `"available rewards"
                                        "history rewards"`
                    }}
                >
                    <div style={{ gridArea: "available" }}>
                        <AvailableToWithdraw navigate={navigate} theme={theme} />
                    </div>
                    <div style={{ gridArea: "history" }}>
                        <WithdrawlHistory t={t} />
                    </div>
                    <div style={{ gridArea: "rewards" }}>
                        <Rewards navigate={navigate} theme={theme} t={t} />
                    </div>
                </div>
            </Box>
        </ThemeProvider>
    );
};

export default PaymentScreen;
